import { useUser } from "components/clerk";
import { useGetUserCurrentQuery } from "store/abcoApi";

export function useUserPermission() {
	const { isLoaded, isSignedIn, user } = useUser();
	const { data: currentUser } = useGetUserCurrentQuery(undefined, {
		skip: !isLoaded || !isSignedIn,
	});

	const permissions = currentUser?.userPermission;

	return {
		isSuperAdmin: (!isLoaded || !isSignedIn) ? false : (user?.publicMetadata.isSuperAdmin ?? false),
		canViewReports: (!isLoaded || !isSignedIn) ? false : (permissions?.canViewReports ?? false),
		canApplyRechargeable: (!isLoaded || !isSignedIn) ? false : (permissions?.canApplyRechargeable ?? false),
	};
}
